import { AudioConversationMessage } from 'v2/core/entities/feedback/content';

export const getMessageIndicesFromSnippetTime = (
  conversation: AudioConversationMessage[],
  snippetTimeToPlay: { startTime: number; endTime: number },
): number[] => {
  const conversationWithIndices = conversation.map(
    (conversationUnit, index) => ({
      ...conversationUnit,
      index,
    }),
  );

  const messagesInSnippetTimeRange = conversationWithIndices.filter(
    (conversationUnit) => {
      return (
        conversationUnit.metadata.startTime < snippetTimeToPlay.endTime &&
        conversationUnit.metadata.endTime >= snippetTimeToPlay.startTime &&
        conversationUnit.metadata.endTime <= snippetTimeToPlay.endTime
      );
    },
  );

  const snippetMessageIndices = messagesInSnippetTimeRange.map(
    (message) => message.index,
  );

  return snippetMessageIndices;
};
